// 依頼受付ステータス検索条件
export class ReceptionStatusSearchCondition {
  isTemporary: boolean;
  isProcessing: boolean;
  isFinished: boolean;
  isDeleted: boolean;

  constructor() {
    this.isProcessing = true;
    this.isTemporary = true;
  }

  getSummary() {
    const summary = (this.isTemporary ? "一時保存，" : "") +
      (this.isProcessing ? "進行中，" : "") +
      (this.isFinished ? "終了，" : "") +
      (this.isDeleted ? "削除済み，" : "");

    return summary.length > 0 ? summary : "アクティブ";
  }

  clone(): ReceptionStatusSearchCondition {
    const newObj = new ReceptionStatusSearchCondition();
    newObj.isTemporary = this.isTemporary;
    newObj.isProcessing = this.isProcessing;
    newObj.isFinished = this.isFinished;
    newObj.isDeleted = this.isDeleted;

    return newObj;
  }
}
